import { transformObjectToCamelCase } from '@utilities';

import type { NotificationResponse } from '../types';

export const transformNotificationsResponse = (data: unknown): NotificationResponse => {
  const response = transformObjectToCamelCase(data) as NotificationResponse;

  return {
    ...response,
    results: response.results?.map((notification) => ({
      ...notification,
      isRead: notification.isRead ?? false,
    })),
  };
};
